export const NOTIFICATIONS_FEATURES = {
  moduleKey: 'notifications',
  features: ['notifications.push', 'notifications.email'] as const,
  featureMeta: {
    'notifications.push': {
      name: 'Push notifications',
      translations: { name: { de: 'Push-Benachrichtigungen', en: 'Push notifications', fr: 'Notifications push', it: 'Notifiche push' } },
    },
    'notifications.email': {
      name: 'Email notifications',
      translations: {
        name: { de: 'E-Mail-Benachrichtigungen', en: 'Email notifications', fr: 'Notifications par e-mail', it: 'Notifiche e-mail' },
      },
    },
  },
} as const;
